import { authHeader } from '../helpers/authHeader';
import { handleAxiosResponse, api_base_url, axiosInstance } from '../services/common.services';
import { handleServiceRequest } from '../services/handleServiceRequest';
import NotificationService from "./NotificationService";

interface ListItemModel
{
    id: number,
    sequence,
    name,
    comment
}
export const listService = {
    getArrivalTimes,
    getCardTypes,
    getCustomerStatuses,
    getJobStatuses,
};
const baseUrl = `/api/lists`;

function getArrivalTimes(): Promise<any>  {
    const getObject = {
        url: `${baseUrl}/arrival-time-windows`,
        customErrorMessage: `Failed to get arrival time options`,
    };
    return handleServiceRequest.get(getObject).then((res: ListItemModel[]) => {
        return MapListItems(res);
    });
}
function getCardTypes(): Promise<any>  {
    const getObject = {
        url: `${baseUrl}/credit-card-types`,
        customErrorMessage: `Failed to get credit card type options`,
    };
    return handleServiceRequest.get(getObject).then((res: ListItemModel[]) => {
        return MapListItems(res);
    });
}

function getCustomerStatuses(): Promise<any>  {
    const getObject = {
        url: `${baseUrl}/customer-statuses`,
        customErrorMessage: `Failed to get customer status options`,
    };
    return handleServiceRequest.get(getObject).then((res: ListItemModel[]) => {
        return MapListItems(res);
    });
}

function getJobStatuses(): Promise<any>  {
    const getObject = {
        url: `${baseUrl}/job-statuses`,
        customErrorMessage: `Failed to get job status options`,
    };
    return handleServiceRequest.get(getObject).then((res: ListItemModel[]) => {
        return MapListItems(res);
    });
}

function MapListItems(list: ListItemModel[]){
    return list.map(x => {
        return{label: x.name, value: x.id}
    });
}